import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import { specificGuestLookup } from "../../utilities/api";
import { LoadingContainer } from "../LoadingContainer";
import OrderSummaryView from "../OrderSummaryView/OrderSummaryView";

export default function OrderDetailsModal({ id, orderId, organizationUUID }) {
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      setIsLoading(true);
      try {
        const res = await specificGuestLookup({
          orderId: id,
          organizationUUID,
        });
        setOrder(res.data);
      } catch (err) {
        console.error("Error fetching order details:", err);
        setError("Failed to load order details.");
      } finally {
        setIsLoading(false);
      }
    };

    if (id && organizationUUID) {
      fetchOrder();
    }
  }, [id, organizationUUID]);

  return (
    <>
      <Modal.Header closeButton className="border-0 pb-0">
        <Stack>
          <Modal.Title className="h3 fw-bold">Order Details</Modal.Title>
          <div className="text-muted mt-1">Order ID: {orderId}</div>
        </Stack>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <LoadingContainer />
        ) : error ? (
          <div className="text-danger">{error}</div>
        ) : order ? (
          <div className="order-details-content">
            <OrderSummaryView order={order} />
          </div>
        ) : (
          <div>No order data found.</div>
        )}
      </Modal.Body>
    </>
  );
}
